import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import SelectableButton from "ui/components/Button/SelectableButton";
import InputSearch from "ui/components/Input/InputSearch";
import ButtonGerarBoleto from "./ButtonGerarBoleto";
import { ArrecadacaoItemResponse } from "features/arrecadacoes/typings";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  ano: string;
  mes: string;
  arrecadacoes: ArrecadacaoItemResponse[];
  selectedTipoBoleto?: boolean;
  onSelectTipoBoleto?: (type?: boolean) => any;
  refetch?: () => any;
  selectedArrecadacoes?: ArrecadacaoItemResponse[];
}

function HeaderTable({
  onSearch,
  value,
  ano,
  mes,
  arrecadacoes,
  selectedTipoBoleto,
  onSelectTipoBoleto,
  refetch,
  selectedArrecadacoes,
}: HeaderTableProps) {
  const onSelectNormal = () => onSelectTipoBoleto?.(false);
  const onSelectExtra = () => onSelectTipoBoleto?.(true);
  const onUnselect = () => onSelectTipoBoleto?.();
  return (
    <Flex flexDir="column">
      <Flex gridGap="16px" flexWrap="wrap">
        <Flex w="100%" maxW="350px">
          <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
        </Flex>

        <Flex flex={1} gridGap={4} flexWrap="wrap">
          <Flex flex={1} pt="4px">
            <Flex gridGap="16px">
              <SelectableButton
                selected={selectedTipoBoleto === true}
                onClick={onSelectExtra}
                onUnselect={onUnselect}
                rounded="full"
                selectedColor={colors.blue300}
                fontSize="14px"
              >
                Boletos extras
              </SelectableButton>
              <SelectableButton
                selected={selectedTipoBoleto === false}
                onClick={onSelectNormal}
                onUnselect={onUnselect}
                rounded="full"
                selectedColor={colors.green500}
                fontSize="14px"
              >
                Boletos normais
              </SelectableButton>
            </Flex>
          </Flex>
          <Flex>
            <ButtonGerarBoleto
              ano={ano}
              mes={mes}
              refetch={refetch}
              arrecadacoes={arrecadacoes}
              selectedArrecadacoes={selectedArrecadacoes}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default HeaderTable;
